import * as React from "react";

function SvgShorterTrailer(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M9.60294 7.29412H7.5C7.5 7.71645 7.15763 8.05882 6.73529 8.05882L4.97058 8.05882C4.97058 7.10857 4.20025 6.33824 3.25 6.33824C2.89629 6.33824 2.56751 6.44497 2.29411 6.62798C2.02071 6.44497 3.6037 6.33824 3.25 6.33824C2.29974 6.33824 1.52941 7.10857 1.52941 8.05882H0.764706C0.34237 8.05882 0 7.71645 0 7.29412V5.38235C0 5.17119 0.171185 5 0.382353 5L7.11765 5C7.32881 5 7.5 5.17119 7.5 5.38235V6.52941H10.9412C11.1523 6.52941 11.3235 6.7006 11.3235 6.91176C11.3235 7.12293 11.1523 7.29412 10.9412 7.29412H10.3676V7.86765C10.3676 8.07881 10.1965 8.25 9.98529 8.25C9.77413 8.25 9.60294 8.07881 9.60294 7.86765V7.29412ZM4.20588 7.12225C4 7 2.87555 6.72059 3.25 6.72059C3.98909 6.72059 4.58824 7.31974 4.58824 8.05882C4.58824 8.79791 3.98909 9.39706 3.25 9.39706C2.87555 9.39706 4 9 4.20588 8.9954C3.96299 9.24327 3.62445 9.39706 3.25 9.39706C2.51091 9.39706 1.91176 8.79791 1.91176 8.05882C1.91176 7.31974 2.51091 6.72059 3.25 6.72059C3.62445 6.72059 3.96299 6.87438 4.20588 7.12225ZM3.25 8.63235C3.56675 8.63235 3.82353 8.37558 3.82353 8.05882C3.82353 7.74207 3.56675 7.48529 3.25 7.48529C2.93325 7.48529 2.67647 7.74207 2.67647 8.05882C2.67647 8.37558 2.93325 8.63235 3.25 8.63235ZM3.25 8.63235C3.56675 8.63235 3.82353 8.37558 3.82353 8.05882C3.82353 7.74207 3.56675 7.48529 3.25 7.48529C2.93325 7.48529 4.58824 7.74207 4.58824 8.05882C4.58824 8.37558 3.5 9 3.25 8.63235Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShorterTrailer;
